import { Auth } from '@jg/auth';
import Preact from 'preact';
import LoggedIn from './LoggedIn';
import LoggedOut from './LoggedOut';
import { UserContent } from '../../content/content';

interface Props {
  content: UserContent;
  showPip: boolean;
  auth: Auth;
  handleShowModal: (showModal: boolean) => void;
}

const User: Preact.FunctionalComponent<Props> = ({
  auth,
  content,
  showPip,
  handleShowModal,
}) =>
  auth.isUserLoggedIn() ? (
    <LoggedIn
      auth={auth}
      menu={content.userMenu}
      showPip={showPip}
      handleShowModal={handleShowModal}
    />
  ) : !auth.isGuest() ? (
    <LoggedOut {...content.loggedOut} />
  ) : null;

export default User;
